import { useHistory } from 'react-router-dom'
import qs from 'qs'

export const useIsExactUPC = () => {
  const history = useHistory()
  const search = history.location.search
  const parsedUrl = qs.parse(search, { ignoreQueryPrefix: true })
  return parsedUrl.exactUpc === 'true'
}
